import * as types from "../actionTypes";

export const loginAction = (user, credentials) => ({
  type: types.LOGIN,
  payload: { user, credentials },
});
export const loggedInAction = (user) => ({
  type: types.LOGEDIN,
  payload: user,
});

export const loginFailed = () => ({ type: types.LOGIN_FAILED });

export const logoutAction = () => ({ type: types.LOGOUT });
